import React from 'react';

import ErrorBoundary from 'app/widgets/ErrorBoundary';

import PrematchContainer from './Container';
import PrematchFavoritesMenuLayer from './layers/Favorites';
import PrematchStagesAndMatchesMenuLayer from './layers/Stages';
import PrematchTournamentsMenuLayer from './layers/Tournaments';
import PrematchUnionsMenuLayer from './layers/Unions';
import PrematchRootMenu from './RootMenu';

const PrematchMenu: React.FC = () => {
  return (
    <PrematchContainer>
      <ErrorBoundary>
        <PrematchRootMenu />
      </ErrorBoundary>

      <ErrorBoundary>
        <PrematchUnionsMenuLayer />
        <PrematchTournamentsMenuLayer />
        <PrematchStagesAndMatchesMenuLayer />
        <PrematchFavoritesMenuLayer />
      </ErrorBoundary>
    </PrematchContainer>
  );
};

export default PrematchMenu;
